import React from 'react'
import Link from 'gatsby-link'
import { withComponent } from 'react-emotion'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/fontawesome-free-solid'

import { Flex, Text } from './Layout'
import { List, ListItem } from './Typography'

const Nav = Flex.withComponent('nav')

const Navigation = ({ location }) => (
  <Nav align="center" justify="space-between" mt={[0, 2, 3]} mb={[5, 6]}>
    <Flex align="center">
      <Link to="/">
        <Text
          fontFamily="monospace"
          fontSize={[0, 1]}
          color="black"
          hover={{ color: 'orange' }}
          px={1}
          pb={1}
          mr={2}
        >
          Dr. Lukas Pustina
        </Text>
      </Link>
    </Flex>
    <List fontFamily="monospace">
      <ListItem display="inline-block">
        <Link to="/">
          <Text
            {...(location.pathname.length === 1
              ? { borderBottom: 2, borderColor: 'orange' }
              : {})}
            fontSize={[0, 1]}
            color="black"
            hover={{ color: 'orange' }}
            px={1}
            pb={0}
            mr={2}
          >
            Home
          </Text>
        </Link>
      </ListItem>
      <ListItem display="inline-block">
        <Link to="/notes/">
          <Text
            {...(location.pathname.indexOf('/notes') === 0
              ? { borderBottom: 2, borderColor: 'orange' }
              : {})}
            fontSize={[0, 1]}
            color="black"
            hover={{ color: 'orange' }}
            px={1}
            pb={0}
            mr={2}
          >
            Notes
          </Text>
        </Link>
      </ListItem>
      <ListItem display="inline-block">
        <Link to="/projects/">
          <Text
            {...(location.pathname.indexOf('/projects') === 0
              ? { borderBottom: 2, borderColor: 'orange' }
              : {})}
            fontSize={[0, 1]}
            color="black"
            hover={{ color: 'orange' }}
            px={1}
            pb={0}
            mr={2}
          >
            Projects
          </Text>
        </Link>
      </ListItem>
      <ListItem display="inline-block">
        <Link to="/publications/">
          <Text
            {...(location.pathname.indexOf('/publications') === 0
              ? { borderBottom: 2, borderColor: 'orange' }
              : {})}
            fontSize={[0, 1]}
            color="black"
            hover={{ color: 'orange' }}
            px={1}
            pb={0}
            mr={2}
          >
            Publications
          </Text>
        </Link>
      </ListItem>
      <ListItem display="inline-block">
        <Link to="/about/">
          <Text
            {...(location.pathname.indexOf('/about') === 0
              ? { borderBottom: 2, borderColor: 'orange' }
              : {})}
            fontSize={[0, 1]}
            color="black"
            hover={{ color: 'orange' }}
            px={1}
            pb={0}
            mr={2}
          >
            About
          </Text>
        </Link>
      </ListItem>
      <ListItem display="inline-block">
        <Link to="/search/">
          <Text
            {...(location.pathname.indexOf('/search') === 0
              ? { borderBottom: 2, borderColor: 'orange' }
              : {})}
            fontSize={[0, 1]}
            color="black"
            hover={{ color: 'orange' }}
            px={1}
            pb={0}
          >
            <FontAwesomeIcon icon={faSearch} />
          </Text>
        </Link>
      </ListItem>
    </List>
  </Nav>
)

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation.js